import { FlexColumn, FlexRow, LabeledData, MaterialIcon, StyledButton } from '@gorila-shared-ui/components';
import { HeadingXSmall } from 'baseui/typography';
import { useStyles } from '../../../hooks/useStyles';
import { User } from '../../../types/user';
import { PermissionTree } from '../../shared/permissionTree/PermissionTree';

type Props = {
  changePassword: (changePassword: boolean) => void;
  user: User;
};

export function ProfileForm({ changePassword, user }: Readonly<Props>) {
  const { css, theme } = useStyles();

  return (
    <>
      <FlexRow
        centered
        classNames={css({ justifyContent: 'space-between' })}
      >
        <HeadingXSmall margin={0}>Usuario: {user.username}</HeadingXSmall>
        <StyledButton
          onClick={() => changePassword(true)}
          endEnhancer={
            <MaterialIcon
              name="lock"
              size={theme.sizing.scale600}
              color={theme.colors.contentInversePrimary}
            />
          }
        >
          Cambiar Contraseña
        </StyledButton>
      </FlexRow>
      <FlexColumn classNames={css({ overflow: 'hidden' })}>
        <LabeledData
          label="Nombre:"
          content={user.name || '-'}
          labelWidth="130px"
        />
        <LabeledData
          label="Email:"
          content={user.email}
          labelWidth="130px"
        />
        <LabeledData
          label="Subcuenta:"
          content={user.subAccount?.name ?? '-'}
          labelWidth="130px"
        />
        {user.permissions && <PermissionTree userPermissions={user.permissions} />}
      </FlexColumn>
    </>
  );
}
